import { JsonObjectType } from 'annotation-tools/utils';
import { uri } from '../../api-endpoint';
import { FetchResultType } from '../../types/common/fetch-result';
import { fetchJson } from '../common/base/fetch/fetch-json';

export const sendLogoutSignal = (token: string): Promise<FetchResultType<
  JsonObjectType,
  JsonObjectType
>> =>
  fetchJson({
    uri: uri.logout,
    method: 'POST',
    body: {},
    token
  });
